export const version = "ethers/5.5.0";
